export var AccordionVariant;
(function (AccordionVariant) {
    AccordionVariant["BASIC"] = "basic";
    AccordionVariant["MULTI_LEVEL"] = "nested";
    AccordionVariant["LONG_LIST"] = "long";
    AccordionVariant["SIDE_NAV"] = "sideNav";
    AccordionVariant["MINIMAL"] = "minimal";
})(AccordionVariant || (AccordionVariant = {}));
//# sourceMappingURL=types.js.map